import React from 'react';
import type { LocationTask } from '../../apis/locationTasks/locationTask.types';

interface KanbanViewProps {
    locationTasks: LocationTask[];
    totalCount: number;
}

export const KanbanView = ({ locationTasks, totalCount }: KanbanViewProps) => {
    return (
        <div className='kanban-view'>
            <h2>Kanban View</h2>
            <ul>
                {locationTasks.map((t) => (
                    <li key={t.id}>{t.name}</li>
                ))}
            </ul>
            <p>
                <strong>Total Count: </strong>
                {totalCount}
            </p>
        </div>
    );
};

export default KanbanView;
